module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f973.f3e30796.svg";